import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Breadcrumbs,
  Link,
  Paper,
  Input,
  Button,
  Divider,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress
} from "@mui/material";
import { Save as SaveIcon } from "@mui/icons-material";
import { postEditQuestion } from "../services/callApi";
import { API_QUERY_KEYS, invalidateApiQueries } from "../utils/apiQueryCache";

function QuestionDetail(props) {
  const [loading, setLoading] = useState(true);
  const [examFile, setExamFile] = useState(null);
  const [examAnswerFile, setExamAnswerFile] = useState(null);
  const { detailData = {}, onBack } = props;
  const [questionData, setquestionData] = useState({});
  const [questionAnswer, setQuestionAnswer] = useState("");
  const [isInitialized, setIsInitialized] = useState(false);
  const [questionImageName, setQuestionImageName] = useState();
  const [answerImageName, setAnswerImageName] = useState();
  const [questionImageData, setQuestioImageData] = useState();
  const [answerImageData, setAnswerImageData] = useState();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const updateInFlightRef = useRef(false);

  // detailDataが変更されるたびにquestionDataを更新
  useEffect(() => {
    if (detailData) {
      setquestionData(detailData);
      setLoading(false);
    }
  }, [detailData]);

  // questionDataが更新されたときにquestionAnswerを設定
  useEffect(() => {
    if (questionData?.correctAnswer && !isInitialized) {
      setQuestionAnswer(questionData.correctAnswer);
      setIsInitialized(true);
    }
    setQuestionImageName(
      questionData?.questionImageUrl?.split("/").pop() || null
    );
    setAnswerImageName(questionData?.correctImageUrl?.split("/").pop() || null);
  }, [questionData, isInitialized]);

  const handleQuestionAnswerChange = (e) => {
    const newAnswer = e.target.value; // 新しい正答を取得
    setQuestionAnswer(newAnswer); // 選択された正答を更新
  };

  const handleExamFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      setQuestionImageName(file.name);
      reader.onload = (e) => {
        setExamFile(e.target.result); // base64に変換された画像データをセット
        setQuestioImageData(e.target.result.split(",")[1]); // Base64データ部分を抽出
      };
      reader.readAsDataURL(file); // 画像をbase64形式に変換
    }
  };

  const handleExamAnswerFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      setAnswerImageName(file.name);
      reader.onload = (e) => {
        setExamAnswerFile(e.target.result);
        setAnswerImageData(e.target.result.split(",")[1]);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isButtonDisabled || updateInFlightRef.current) {
      return;
    }

    // 送信データ
    const payload = {
      question_id: questionData?.questionId,
      question_part: questionData?.questionPart,
      question_image_name: questionImageName,
      correct_image_name: answerImageName,
      answer_choices: questionData?.answerChoices,
      correct_answer: questionAnswer,
      is_active: true,
    };

    if (questionImageData !== null) {
      payload.question_image = questionImageData;
      payload.question_image_name = questionImageName;
    }

    if (answerImageData !== null) {
      payload.answer_image = answerImageData;
      payload.correct_image_name = answerImageName;
    }
    updateInFlightRef.current = true;
    setIsButtonDisabled(true);

    console.log("request parameters" + JSON.stringify(payload));

    const fetchEditQuestion = async (prams) => {
      try {
        const response = await postEditQuestion(prams);
        console.log(response);
        invalidateApiQueries(
          API_QUERY_KEYS.questionList,
          API_QUERY_KEYS.questionDetail(questionData?.questionId)
        );
        await props.onUpdated?.();
        alert("問題情報が更新されました");
      } catch (error) {
        console.error("更新失敗:", error);
        alert("更新に失敗しました。もう一度試してください。");
      } finally {
        updateInFlightRef.current = false;
        setIsButtonDisabled(false);
      }
    };
    await fetchEditQuestion(payload);
  };

  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" sx={{ minHeight: '40vh' }}>
          <CircularProgress />
        </Box>
      ) : questionData ? (
        <>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: { xs: 'flex-start', sm: 'center' },
              mb: 2,
              flexDirection: { xs: 'column', sm: 'row' },
              gap: { xs: 1, sm: 0 }
            }}
          >
            <Typography variant="h5" component="h1">問題詳細</Typography>
            <Breadcrumbs aria-label="breadcrumb" sx={{ mt: { xs: 1, sm: 0 } }}>
              <Link
                underline="hover"
                color="inherit"
                sx={{ cursor: "pointer" }}
                onClick={(e) => { e.preventDefault(); onBack && onBack(); }}
              >
                問題一覧
              </Link>
              <Typography color="text.primary">詳細</Typography>
            </Breadcrumbs>
          </Box>

          <Paper sx={{ p: { xs: 2, sm: 3 }, mt: 2 }} elevation={3}>
          {/* <Typography variant="h3" gutterBottom>
            <UploadFileIcon sx={{ mr: 1 }} />
            問題詳細
          </Typography> */}

          <form onSubmit={handleSubmit}>
            {/* 問題番号 */}
            <Box sx={{ display: 'flex', alignItems: { xs: 'flex-start', sm: 'center' }, height: { xs: 'auto', sm: '3rem' }, flexDirection: { xs: 'column', sm: 'row' } }}>
              <Typography variant="subtitle1" sx={{ width: { xs: '100%', sm: '20%' }, fontWeight: { xs: 'bold', sm: 'normal' } }}>
                問題番号
              </Typography>
              <Divider orientation="vertical" flexItem sx={{ mx: 2, display: { xs: 'none', sm: 'block' } }} />
              <Typography variant="body1" sx={{ width: { xs: '100%', sm: '80%' }, mt: { xs: 0.5, sm: 0 } }}>
                {questionData?.questionId}
              </Typography>
            </Box>

            {/* 変更日時 */}
            <Box sx={{ display: 'flex', alignItems: { xs: 'flex-start', sm: 'center' }, height: { xs: 'auto', sm: '3rem' }, flexDirection: { xs: 'column', sm: 'row' } }}>
              <Typography variant="subtitle1" sx={{ width: { xs: '100%', sm: '20%' }, fontWeight: { xs: 'bold', sm: 'normal' } }}>
                変更日時
              </Typography>
              <Divider orientation="vertical" flexItem sx={{ mx: 2, display: { xs: 'none', sm: 'block' } }} />
              <Typography variant="body1" sx={{ width: { xs: '100%', sm: '80%' }, mt: { xs: 0.5, sm: 0 } }}>
                {questionData?.updatedAt}
              </Typography>
            </Box>

            {/* 問題画像アップロード */}
            <Box sx={{ display: 'flex', alignItems: { xs: 'flex-start', sm: 'center' }, height: { xs: 'auto', sm: '6rem' }, flexDirection: { xs: 'column', sm: 'row' } }}>
              <Typography variant="subtitle1" sx={{ width: { xs: '100%', sm: '20%' }, fontWeight: { xs: 'bold', sm: 'normal' } }}>
                問題画像
              </Typography>
              <Divider orientation="vertical" flexItem sx={{ mx: 2, display: { xs: 'none', sm: 'block' } }} />
              <Box sx={{
                display: 'flex',
                alignItems: { xs: 'flex-start', sm: 'center' },
                width: { xs: '100%', sm: '80%' },
                gap: 2,
                flexDirection: { xs: 'column', sm: 'row' },
                flexWrap: { xs: 'wrap', sm: 'nowrap' }
              }}>
                <Box sx={{
                  mt: { xs: 1, sm: 0 },
                  width: { xs: '100%', sm: 'auto' },
                  minWidth: { sm: 200 },
                  flexShrink: 0,
                  display: 'flex',
                  justifyContent: { xs: 'flex-start', sm: 'flex-start' }
                }}>
                  <Input
                    type="file"
                    onChange={handleExamFileChange}
                    inputProps={{ accept: "image/jpeg" }}
                  />
                </Box>
                {(() => {
                  const imgWidthSm = questionData?.questionPart === 3 ? '60%' : '70%';
                  const imgMaxMd = questionData?.questionPart === 3 ? '25%' : '100%';
                  const src = examFile
                    ? examFile
                    : "https://dev-aptitude-test-api-image-bucket.s3.ap-northeast-1.amazonaws.com" + questionData?.questionImageUrl;
                  return (
                    <Box sx={{ mt: 2, width: { xs: '100%', sm: imgWidthSm, md: 'auto' } }}>
                      <Box
                        component="img"
                        src={src}
                        alt="Selected Question"
                        sx={{ maxWidth: { xs: '100%', sm: '100%', md: imgMaxMd }, height: 'auto' }}
                      />
                    </Box>
                  );
                })()}
              </Box>
            </Box>

            {/* 回答アップロード */}
            <Box sx={{ display: 'flex', alignItems: { xs: 'flex-start', sm: 'center' }, height: { xs: 'auto', sm: '6rem' }, flexDirection: { xs: 'column', sm: 'row' } }}>
              <Typography variant="subtitle1" sx={{ width: { xs: '100%', sm: '20%' }, fontWeight: { xs: 'bold', sm: 'normal' } }}>
                回答画像
              </Typography>
              <Divider orientation="vertical" flexItem sx={{ mx: 2, display: { xs: 'none', sm: 'block' } }} />
              <Box sx={{
                display: 'flex',
                alignItems: { xs: 'flex-start', sm: 'center' },
                width: { xs: '100%', sm: '80%' },
                gap: 2,
                flexDirection: { xs: 'column', sm: 'row' },
                flexWrap: { xs: 'wrap', sm: 'nowrap' }
              }}>
                <Box sx={{
                  mt: { xs: 1, sm: 0 },
                  width: { xs: '100%', sm: 'auto' },
                  minWidth: { sm: 200 },
                  flexShrink: 0,
                  display: 'flex',
                  justifyContent: { xs: 'flex-start', sm: 'flex-start' }
                }}>
                  <Input
                    type="file"
                    onChange={handleExamAnswerFileChange}
                    inputProps={{ accept: "image/jpeg" }}
                  />
                </Box>
                {(() => {
                  const imgWidthSm = questionData?.questionPart === 3 ? '80%' : '70%';
                  const imgMaxMd = questionData?.questionPart === 3 ? '40%' : '100%';
                  const src = examAnswerFile
                    ? examAnswerFile
                    : "https://dev-aptitude-test-api-image-bucket.s3.ap-northeast-1.amazonaws.com" + questionData?.correctImageUrl;
                  return (
                    <Box sx={{ mt: 2, width: { xs: '100%', sm: imgWidthSm, md: 'auto' } }}>
                      <Box
                        component="img"
                        src={src}
                        alt="Selected Answer"
                        sx={{ maxWidth: { xs: '100%', sm: '100%', md: imgMaxMd }, height: 'auto' }}
                      />
                    </Box>
                  );
                })()}
              </Box>
            </Box>

            {/* 正答 */}
            <Box sx={{ display: 'flex', alignItems: { xs: 'flex-start', sm: 'center' }, height: { xs: 'auto', sm: '5rem' }, flexDirection: { xs: 'column', sm: 'row' } }}>
              <Typography variant="subtitle1" sx={{ width: { xs: '100%', sm: '20%' }, fontWeight: { xs: 'bold', sm: 'normal' } }}>
                正答
              </Typography>
              <Divider orientation="vertical" flexItem sx={{ mx: 2, display: { xs: 'none', sm: 'block' } }} />
              <Box sx={{ width: { xs: '100%', sm: '80%' }, mt: { xs: 0.5, sm: 0 } }}>
                <FormControl fullWidth size="small">
                  <InputLabel id="question-answer-label">正答</InputLabel>
                  <Select
                    labelId="question-answer-label"
                    value={questionAnswer}
                    label="正答"
                    onChange={handleQuestionAnswerChange}
                  >
                    {questionData?.answerChoices?.map((choice, index) => (
                      <MenuItem key={index} value={choice}>
                        {choice}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Box>

            <Box sx={{ mt: { xs: 2, sm: 3 }, textAlign: 'center' }}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                startIcon={<SaveIcon />}
                disabled={isButtonDisabled}
              >
                保存
              </Button>
            </Box>
            <Typography variant="body2" sx={{ mt: { xs: 1.5, sm: 2 } }}>
              ※3部の画像のみ、2倍のサイズで書き出してください。
            </Typography>
          </form>
        </Paper>
        </>
      ) : (
        <Typography>指定されたユーザーが見つかりません。</Typography>
      )}
    </Box>
  );
}

export default QuestionDetail;
